// This file is generated by generate.py in metrics generator. DO NOT EDIT.

export enum SensedKey {
  Pm1 = 'pm1',
  Pm25 = 'pm2.5',
  Pm10 = 'pm10',
  No2 = 'no2',
  No = 'no',
  Nox = 'nox',
  Co = 'co',
  TempInternal = 'temperatureInternal',
  RhInternal = 'rHInternal',
  TempAmbient = 'temperatureAmbient',
  RhAmbient = 'rHAmbient',
  AtmPressure = 'atmPressure',
  Wind = 'windVector',
  Ozone = 'ozone',
  Tvoc = 'tVoc',
  BlackCarbon = 'blackCarbon',
}
